export default "__VITE_ASSET__8Hmlt1Dw__"